import getInfoFromURL from './getInfoFromURL'
export default function () {
  const [urlPrefix, , , , headers] = getInfoFromURL()

  const baseUrl = urlPrefix
  const url = `/${baseUrl}/api/v2/login/logout`

  window.fetch(url, {
    method: 'POST',
    headers: {
      ...headers
    }
  })
}
